import {
    AddClusterNodeConfigFormValues,
    ClusterConfigurator,
    ClusterConfiguratorFormValues,
} from '../ClusterConfigurator';
import merge from 'deepmerge';
import React from 'react';
import { CcClusterType } from '../../../../services/models/CcCluster';
import PostgreSqlNodeConfiguration from './PostgreSqlNodeConfiguration';

export interface PostgreSqlFormValues extends ClusterConfiguratorFormValues {
    nodeConfig: AddClusterNodeConfigFormValues & {
        serverPort?: number;
        adminUser?: string;
        adminPassword?: string;
        serverDataDirectory?: string;
    };
    synchronousReplication?: {
        [key: string]: boolean;
    };
    topologyServerPort?: {
        [key: string]: number;
    };
    databaseExtension?: {
        [key: string]: boolean;
    };
    topologyLogFile?: {
        [key: string]: string;
    };
}

export default class PostgreSqlConfigurator extends ClusterConfigurator {
    public static getDefaults(): PostgreSqlFormValues {
        return merge(ClusterConfigurator.getDefaults(), {
            nodeConfig: {
                serverPort: 5432,
            },
        });
    }

    public static getJobData(formValues: PostgreSqlFormValues): any {
        const { nodeConfig, details } = formValues;
        return merge(ClusterConfigurator.getJobData(formValues), {
            cluster_type: CcClusterType.TYPE_POSTGRESQL.toLowerCase(),
            db_user: nodeConfig.adminUser,
            db_password: nodeConfig.adminPassword,
            datadir: nodeConfig.serverDataDirectory,
            port: nodeConfig.serverPort,
            enterprise_token: details.enterpriseToken,
        });
    }

    public static getVendors() {
        return [
            {
                name: 'PostgreSQL',
                value: 'postgresql',
            },
            {
                name: 'PostgreSQL Enterprise DB',
                value: 'enterprisedb',
            },
        ];
    }

    public static getNodeConfigurationValidate(): string[][] {
        return [
            ['nodeConfig', 'serverPort'],
            ['nodeConfig', 'adminUser'],
            ['nodeConfig', 'adminPassword'],
        ];
    }

    public static getNodeConfigurationStep(props: any): React.ReactNode {
        return <PostgreSqlNodeConfiguration {...props} />;
    }
}
